// TODO: This needs to be set in balancing/uiDefinitions!!!
import { IdLeagueGifts } from "../../constants/IdLeagueGifts";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { EventType } from "../balancing/types/BalancingCore";
export var mapDialogRewardsTitle = new Map([
    [
        EventType.PlayerLeague,
        new Map([
            [IdLeagueGifts.LeagueFreeGift, IdLoca.leagueReward_gift_title],
            [IdLeagueGifts.LeagueGoldGift, IdLoca.leagueReward_goldPackage_title],
        ]),
    ],
    [
        EventType.CoopLeague,
        new Map([
            [IdLeagueGifts.LeagueFreeGift, IdLoca.leagueReward_gift_title],
            [IdLeagueGifts.LeagueGoldGift, IdLoca.coopLeagueReward_goldPackage_title],
        ]),
    ],
    [
        EventType.CollectLeague,
        new Map([
            [IdLeagueGifts.LeagueFreeGift, IdLoca.leagueReward_gift_title],
            [IdLeagueGifts.LeagueGoldGift, IdLoca.collectLeague_goldPackage_title],
        ]),
    ],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/MapDialogRewardsTitle.tsx
// module id = 2947
// module chunks = 3